import { Navigate, Route, Routes } from "react-router-dom";
import { TopBar } from "./components/TopBar";
import { Footer } from "./components/Footer";
import { PrayerPage } from "./pages/PrayerPage";
import { CalendarPage } from "./pages/CalendarPage";
import { ConverterPage } from "./pages/ConverterPage";
import { EventsPage } from "./pages/EventsPage";
import { LocaleProvider } from "./lib/i18n";

export function App() {
  return (
    <LocaleProvider>
      <TopBar />
      <Routes>
        <Route path="/" element={<PrayerPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/converter" element={<ConverterPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </LocaleProvider>
  );
}
